module.exports = __webpack_public_path__ + "img/select-lang-btn-es.325e00a6.png";